import React from 'react'
import { useTranslation } from 'react-i18next'

const OrganizationAvatar = ({
  addOrga,
  color,
  isCurrentOrga,
  hideSubTitle,
  notificationNumber,
  onClick,
  subTitle,
  title,
  fullOrgName
}) => {
  const { t } = useTranslation()
  const renderNotifications = (notification) =>
    notification > 0 && (
      <div className={`orga-avatar__notification ${notification > 9 ? 'orga-avatar__notification--big' : ''}`}>
        {notification}
      </div>
    )

  const renderSubTitle = () => <div className='orga-avatar__sub-title'>{subTitle}</div>

  const colorClass = () => {
    if (color) return `orga-avatar__avatar--${color.name || color}`
    if (addOrga || isCurrentOrga) return ''
    return 'orga-avatar__avatar--green'
  }

  const handleKeyDown = (e) => {
    if (e.keyCode.toString() === '13') {
      onClick()
    }
  }
  return (
    <div className='orga-avatar__container'>
      <button
        title={hideSubTitle ? subTitle : ''}
        aria-label={
          fullOrgName
            ? notificationNumber > 0
              ? t('organization.orgWithNotification', { orgName: fullOrgName, count: notificationNumber })
              : fullOrgName
            : t('organization.create.pageTitle')
        }
        tabIndex='0'
        onClick={onClick}
        onKeyDown={(e) => handleKeyDown(e)}
        className={`orga-avatar__avatar ${colorClass()} ${isCurrentOrga ? 'orga-avatar__avatar--current-orga' : ''}  ${
          addOrga ? 'orga-avatar__avatar--add-orga' : ''
        }`}>
        {!addOrga && renderNotifications(notificationNumber)}
        <div
          className={`${addOrga ? 'orga-avatar__title--add' : 'orga-avatar__title'} ${
            title && title.length > 3 ? 'orga-avatar__title--long' : ''
          }`}>
          {addOrga ? '+' : title}
        </div>
      </button>
      {!addOrga && !hideSubTitle && renderSubTitle()}
    </div>
  )
}

export default OrganizationAvatar
